<template>
    <div class="fullHeight">
        <MypageSideMenu @set="initialize" :memberDropClose="true"/>
        <Card
            :page_title="page_title"
            iconclass="icon-icon-mypage mypage-title-icon"
        >
            <div class="col-sm-12">
                <div class="graywindow">
                    <div v-if="member_rank">
                        <div class="row justify-content-start m-3">
                            <div class="col-sm-5" v-if="select_point_use">
                                <select
                                    class="form-control"
                                    v-model="get_golf_code"
                                    @change="ChangeGolfCode"
                                >
                                    <option
                                        v-for="data in get_point_use_type"
                                        :key="data.golf_code"
                                        :value="data.golf_code"
                                    >
                                        {{ data.golf_name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="my-3 messageBox row row-notMx justify-content-around">
                            <div class="col-sm-3 align-self-center">
                                <div class="circle-container">
                                    <div class="mypage-circle-content">保有ポイント合計</div>
                                    <div class="mypage-point-circle">{{ this.total_points.toLocaleString() }}pt</div>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div>
                                    <div class="my-2">
                                        <div class="row row-notMx justify-content-between">
                                            <div>通常ポイント</div>
                                            <div class="font-weight-bold">{{ this.total_normal.toLocaleString() }}pt</div>
                                        </div>
                                        <div class="row row-notMx">
                                            <small v-if="this.min_valid_date_limited_normal">（最短有効期限：{{ this.min_valid_date_limited_normal | date_format_ja('-') }}）</small>
                                        </div>
                                        <div class="mypage-gray-border-bottom pt-1"></div>
                                    </div>
                                    <div class="my-2">
                                        <div class="row row-notMx justify-content-between">
                                            <div>期間限定ポイント</div>
                                            <div class="font-weight-bold">{{ this.total_limited.toLocaleString() }}pt</div>
                                        </div>
                                        <div class="row row-notMx">
                                            <small v-if="this.min_valid_date_limited">（最短有効期限：{{ this.min_valid_date_limited | date_format_ja('-') }}）</small>
                                        </div>
                                        <div class="mypage-gray-border-bottom pt-1"></div>
                                    </div>
                                    <div class="my-2">
                                        <div class="row row-notMx justify-content-between">
                                            <div>利用予定ポイント</div>
                                            <div class="font-weight-bold">{{ this.total_reserve.toLocaleString() }}pt</div>
                                        </div>
                                        <div class="row row-notMx">
                                            <small v-if="this.play_date">（直近利用予定：{{ this.play_date | date_format_ja('-') }}）</small>
                                        </div>
                                        <div class="mypage-gray-border-bottom pt-1"></div>
                                    </div>
                                    <div class="mb-4 mt-2">
                                        <div class="row row-notMx justify-content-between">
                                            <div>獲得予定ポイント</div>
                                            <div class="font-weight-bold">{{ this.total_expected.toLocaleString() }}pt</div>
                                        </div>
                                        <div class="row row-notMx">
                                            <small v-if="this.expected_date">（直近獲得予定：{{ this.expected_date | date_format_ja('-') }}）</small>
                                        </div>
                                        <div class="mypage-gray-border-bottom pt-1 mb-2"></div>
                                    </div>
                                </div>
                                <div>
                                    <button
                                        type="button"
                                        class="bluebackbutton btn-md btn-block"
                                        v-on:click="GotoPoint()"
                                    >ポイント履歴を見る</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="member_rank">
                        <div class="messageBox mypage-gray-border-top py-3 mypage-limit-table">
                            <h5 class="font-weight-bold text-center mb-4">期間限定ポイント一覧</h5>
                            <div class="row row-notMx justify-content-around mb-4">
                                <div v-for="data in get_limited_point" :key="data.id" class="col-sm-3 col-notMx table-line limit-table-flex table-color">
                                    <div class="mypage-black-border"></div>
                                    <div class="row row-notMx justify-content-between mypage-gray-border-bottom">
                                        <div class="col-4 col-notMx">有効期限</div>
                                        <div class="col-8 col-notMx font-weight-bold text-right">{{ data.valid_date | date_format_ja('-') }}</div>
                                    </div>
                                    <div class="row row-notMx justify-content-between mypage-gray-border-bottom">
                                        <div class="col-4 col-notMx">内容</div>
                                        <div class="col-8 col-notMx font-weight-bold text-right">{{ data.action }}</div>
                                    </div>
                                    <div class="row row-notMx justify-content-between mypage-gray-border-bottom">
                                        <div class="col-4 col-notMx">区分</div>
                                        <div class="col-8 col-notMx font-weight-bold text-right">{{ data.point_type_display }}</div>
                                    </div>
                                    <div class="row row-notMx justify-content-between mypage-gray-border-bottom">
                                        <div class="col-4 col-notMx">ポイント</div>
                                        <div class="col-8 col-notMx font-weight-bold text-right">{{ data.point.toLocaleString() }}</div>
                                    </div>
                                    <div class="row row-notMx justify-content-between mypage-gray-border-bottom">
                                        <div class="col-4 col-notMx">コメント</div>
                                        <div class="col-8 col-notMx font-weight-bold text-right">{{ data.comment }}</div>
                                    </div>
                                </div>
                                <template v-if="get_limited_point_disp_count === 1">
                                    <div class="col-sm-3 table-line d-sm-block d-none col-notMx limit-table-flex">
                                        <div class="mypage-black-border"></div>
                                        <div class="row row-notMx justify-content-between mypage-gray-border-bottom">
                                            <div class="col-4 col-notMx">&nbsp;</div>
                                            <div class="col-8 col-notMx font-weight-bold text-right">&nbsp;</div>
                                        </div>
                                        <div class="row row-notMx justify-content-between mypage-gray-border-bottom">
                                            <div class="col-4 col-notMx">&nbsp;</div>
                                            <div class="col-8 col-notMx font-weight-bold text-right">&nbsp;</div>
                                        </div>
                                        <div class="row row-notMx justify-content-between mypage-gray-border-bottom">
                                            <div class="col-4 col-notMx">&nbsp;</div>
                                            <div class="col-8 col-notMx font-weight-bold text-right">&nbsp;</div>
                                        </div>
                                        <div class="row row-notMx justify-content-between mypage-gray-border-bottom">
                                            <div class="col-4 col-notMx">&nbsp;</div>
                                            <div class="col-8 col-notMx font-weight-bold text-right">&nbsp;</div>
                                        </div>
                                        <div class="row row-notMx justify-content-between mypage-gray-border-bottom">
                                            <div class="col-4 col-notMx">&nbsp;</div>
                                            <div class="col-8 col-notMx font-weight-bold text-right">&nbsp;</div>
                                        </div>
                                    </div>
                                    <div class="col-sm-3 table-line d-sm-block d-none col-notMx limit-table-flex">
                                        <div class="mypage-black-border"></div>
                                        <div class="row row-notMx justify-content-between mypage-gray-border-bottom">
                                            <div class="col-4 col-notMx">&nbsp;</div>
                                            <div class="col-8 col-notMx font-weight-bold text-right">&nbsp;</div>
                                        </div>
                                        <div class="row row-notMx justify-content-between mypage-gray-border-bottom">
                                            <div class="col-4 col-notMx">&nbsp;</div>
                                            <div class="col-8 col-notMx font-weight-bold text-right">&nbsp;</div>
                                        </div>
                                        <div class="row row-notMx justify-content-between mypage-gray-border-bottom">
                                            <div class="col-4 col-notMx">&nbsp;</div>
                                            <div class="col-8 col-notMx font-weight-bold text-right">&nbsp;</div>
                                        </div>
                                        <div class="row row-notMx justify-content-between mypage-gray-border-bottom">
                                            <div class="col-4 col-notMx">&nbsp;</div>
                                            <div class="col-8 col-notMx font-weight-bold text-right">&nbsp;</div>
                                        </div>
                                        <div class="row row-notMx justify-content-between mypage-gray-border-bottom">
                                            <div class="col-4 col-notMx">&nbsp;</div>
                                            <div class="col-8 col-notMx font-weight-bold text-right">&nbsp;</div>
                                        </div>
                                    </div>
                                </template>
                                <!-- 表示が2の時のoffset -->
                                <template v-if="get_limited_point_disp_count === 2">
                                    <div class="col-sm-3 table-line d-sm-block d-none col-notMx limit-table-flex">
                                        <div class="mypage-black-border"></div>
                                        <div class="row row-notMx justify-content-between mypage-gray-border-bottom">
                                            <div class="col-4 col-notMx">&nbsp;</div>
                                            <div class="col-8 col-notMx font-weight-bold text-right">&nbsp;</div>
                                        </div>
                                        <div class="row row-notMx justify-content-between mypage-gray-border-bottom">
                                            <div class="col-4 col-notMx">&nbsp;</div>
                                            <div class="col-8 col-notMx font-weight-bold text-right">&nbsp;</div>
                                        </div>
                                        <div class="row row-notMx justify-content-between mypage-gray-border-bottom">
                                            <div class="col-4 col-notMx">&nbsp;</div>
                                            <div class="col-8 col-notMx font-weight-bold text-right">&nbsp;</div>
                                        </div>
                                        <div class="row row-notMx justify-content-between mypage-gray-border-bottom">
                                            <div class="col-4 col-notMx">&nbsp;</div>
                                            <div class="col-8 col-notMx font-weight-bold text-right">&nbsp;</div>
                                        </div>
                                        <div class="row row-notMx justify-content-between mypage-gray-border-bottom">
                                            <div class="col-4 col-notMx">&nbsp;</div>
                                            <div class="col-8 col-notMx font-weight-bold text-right">&nbsp;</div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <nav aria-label="Page navigation">
                            <ul class="pagination pagination-sm">
                                <li class="page-item" @click="ClickPagination('Limited', 'Previous')">
                                    <span class="framebutton Mypagepoint_pagelinkwidth py-1">前へ</span>
                                </li>
                                <li class="pagination-center">
                                    <span>{{ display_pagination }} / {{ max_pagination }}</span>
                                </li>
                                <li class="page-item" @click="ClickPagination('Limited', 'Next')">
                                    <span class="framebutton Mypagepoint_pagelinkwidth py-1">次へ</span>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </Card>
        <MypageFooter
            @out-click="logOutBtn"
        />
        <MypageMenuFooter/>
    </div>
</template>

<script>
import MypageFooter from './MypageFooter';
import MypageSideMenu from './MypageSideMenu';
import MyPageQrCode from '../components/MyPage/MyPageQrCode';
import MyPageBarCode from '../components/MyPage/MyPageBarCode';
import MyPageMemberCode from '../components/MyPage/MyPageMemberCode';
import { MEMBER_LOG_OUT } from "../../constants/signout";
import { GET_POINT_LIMITED_LIST, GET_MYPAGE_TOP_INFO, GET_GOLF_COURSE_POINT_TOTAL } from '../../constants/mypage_top';
import { mapGetters } from 'vuex';
import { memberStatusMixin } from './memberStatusMixin';
import Icon from '../components/Icon';
import { utilityMixin } from '../../mixins/utility';
import MypageMenuFooter from './MypageMenuFooter';
import Card from '../components/Card';

export default {
    components: {
        MypageSideMenu,
        MypageMenuFooter,
        MypageFooter,
        MyPageQrCode,
        MyPageBarCode,
        MyPageMemberCode,
        Icon,
        Card
    },
    mixins: [memberStatusMixin, utilityMixin],
    data () {
        return {
            // ページタイトル
            page_title: 'ポイント確認',
            classBlack: 'text-body',
            classRed: 'text-danger',
            member_rank: false,
            member_no: '',
            use_golf_code: '',
            golf_group_code: process.env.MIX_GROUP_CODE,
            from_set_data: {
                // 会員番号
                member_no: '',
                // フルネーム
                full_name: '',
            },
            line_status: false,
            line_setting_link: {
                title: 'LINEアカウント連携',
                to: '/mypage-line-setting'
            },
            select_point_use: false,
            get_point_use_type: [],
            get_golf_code: '',
            total_points: 0,
            total_normal: 0,
            total_limited: 0,
            total_expected: 0,
            total_reserve: 0,
            // 表示中の期間期限ポイントページネーション数
            display_pagination: 1,
            // 取得した期間期限ポイントデータ格納
            get_limited_point: [],
            // 表示する期間期限ポイントデータ格納
            display_limited_point: [],
            // 期間期限ポイント最大ページネーション数
            max_pagination: 1,
            // 期間限定ポイント一覧のカウント数
            get_limited_point_disp_count: 0,
            display_begin_row: 0,
            display_limit_rows: 3,
            point_flag_normal: 1,
            point_flag_limited_normal: 2,
            point_flag_limited: 3,
            min_valid_date_limited_normal: '',
            min_valid_date_limited: '',
            expected_date: '',
            play_date: '',
            // メッセージ受信の連絡
            message_info: '',
            reserveData: [],
            // ロゴのURL
            imgPath: "/images/" + process.env.MIX_STYLE_NAME + "_logo_2.png",
            // 会員コードの初期表示（true：QR、false：バーコード）
            defaultCode: true,
            showMemberCode: false,
            chatOff: false
        };
    },
    computed: {
        ...mapGetters('auth', [
            "loginMemberLineFlag"
        ]),
        paginationDisabled () {
            return this.max_pagination === 1 || this.max_pagination === 0;
        },
        setCodeIcon () {
            return this.defaultCode ? 'icon-qrcode' : 'icon-barcode';
        },
        setCahtboxCss () {
            return this.chatOff ? 'chatOff' : '';
        }
    },
    async created () {
        await this.initialize();
    },
    watch: {
        display_pagination: function (now) {
            this.display_limited_point = [];
            const nextNum = now * this.display_limit_rows;
            for (var i = nextNum - this.display_limit_rows; i < nextNum; i++) {
                if (this.get_limited_point[i] !== undefined) {
                    this.display_limited_point.push(this.get_limited_point[i])
                }
            }
        },
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        async initialize () {
            this.$store.commit("loading/setIsLoading", true);
            // await this.GetLoginUserMemberStatus();
            // await this.getDefaltCode();
            // await this.getChatBoxSettingValue();
            // await this.GetReserveInfo();
            // this.GetMemberRank();
            // this.GetMessegeInfo();
            await this.getMypageTop();
            if (this.loginMemberLineFlag) {
                this.line_status = true
                this.line_setting_link.title = 'LINEアカウント連携解除';
                this.line_setting_link.to = '/mypage-line-setting-quit';
            }
            this.from_set_data.member_no = this.$store.state.auth.loginMember.member_no;
            this.from_set_data.full_name = this.$store.state.auth.loginMember.family_name + ' ' + this.$store.state.auth.loginMember.given_name;
            // ログインしている会員番号を取得後に表示するバーコードとQRを作成する（各コンポーネントの読み込み時では、会員番号を取得できていないため正しく表示できない）
            // this.GetMemberRank();
            // this.GetMessegeInfo();
            // this.$store.commit("loading/setIsLoading", false);
        },
        getMypageTop: async function () {
            try {
                this.$apollo.query({
                    query: GET_MYPAGE_TOP_INFO,
                    variables: {
                        golf_group_code: this.golf_group_code,
                        golf_code: this.$store.state.mypage.useGolfCode,
                        begin_row: this.display_begin_row,
                        limit_rows: this.display_limit_rows
                    }
                }).then(res => {
                    this.chatOff = !Boolean(res.data.GetMypageTopInfo.chatboxSetting);
                    this.reserveData = res.data.GetMypageTopInfo.ReserveInfo.ReserveList[0];
                    this.member_rank = res.data.GetMypageTopInfo.memberRank;
                    if (this.member_rank) {
                        if (res.data.GetMypageTopInfo.pointUseType !== null) {
                            this.select_point_use = true;
                            this.get_point_use_type = res.data.GetMypageTopInfo.pointUseType;
                            if (this.$store.state.mypage.useGolfCode !== null){
                                this.use_golf_code = this.$store.state.mypage.useGolfCode;
                            }else{
                                this.use_golf_code = this.get_point_use_type[0].golf_code;
                            }
                            this.get_golf_code = this.use_golf_code;
                            this.$store.commit('mypage/useGolfCode', this.get_golf_code);
                        } else {
                            this.select_point_use = false;
                        }
                        // ポイントの合計値取得
                        if (!res.data.GetMypageTopInfo.totalPoint.total_all) {
                            this.total_points = 0;
                            this.total_normal = 0;
                            this.total_limited = 0;
                            this.min_valid_date_limited_normal = '';
                            this.min_valid_date_limited = '';
                        } else {
                            this.total_points = res.data.GetMypageTopInfo.totalPoint.total_all;
                            this.total_normal = res.data.GetMypageTopInfo.totalPoint.total_normal;
                            this.total_limited = res.data.GetMypageTopInfo.totalPoint.total_limited;
                            this.min_valid_date_limited_normal = res.data.GetMypageTopInfo.validDate.total_limited_normal;
                            this.min_valid_date_limited = res.data.GetMypageTopInfo.validDate.total_limited;
                        }
                        if (!res.data.GetMypageTopInfo.totalPoint.total_expected) {
                            this.total_expected = 0;
                            this.expected_date = '';
                        } else {
                            this.total_expected = res.data.GetMypageTopInfo.totalPoint.total_expected;
                            this.expected_date = res.data.GetMypageTopInfo.validDate.expected_date;
                        }
                        if (!res.data.GetMypageTopInfo.totalPoint.total_reserve) {
                            this.total_reserve = 0;
                            this.play_date = '';
                        } else {
                            this.total_reserve = res.data.GetMypageTopInfo.totalPoint.total_reserve;
                            this.play_date = res.data.GetMypageTopInfo.validDate.play_date;
                        }
                        this.get_limited_point = [];

                        // 期間限定ポイントのデータ取得
                        this.get_limited_point = res.data.GetMypageTopInfo.MemberLimitedPointList;
                        // 期間限定ポイントのデータ表示数
                        this.get_limited_point_disp_count = res.data.GetMypageTopInfo.MemberLimitedPointList.length;
                        if (this.get_limited_point) {
                            // 期間期限ポイントの最大ページネーション数
                            if (res.data.GetMypageTopInfo.count === 0) {
                                res.data.GetMypageTopInfo.count = 1;
                            }
                            this.max_pagination = Math.ceil(res.data.GetMypageTopInfo.count / this.display_limit_rows);
                        }
                    }
                    this.$store.commit("loading/setIsLoading", false);
                })
            } catch(err) {
                this.$store.commit("loading/setIsLoading", false);
                console.log("エラーが起こりました:" + err);
            }
        },
        /** ----------------------------------------------
         * ポイントがマイナス値の場合は赤字表示
         * ---------------------------------------------- */
        fontColor: function(data) {
            if (data.point < 0) {
                return this.classRed;
            } else {
                return this.classBlack;
            }
        },
        /** --------------------------------------------
         * 会員情報を取得
         * -------------------------------------------- */
        setMember: function (member_no) {
            this.from_set_data.member_no =this.$parent.member_no;
            this.from_set_data.full_name = this.$parent.family_name + ' ' + this.$parent.given_name;
        },
        ChangeGolfCode: async function () {
            this.total_points = '';
            this.display_limited_point = [];
            this.max_pagination = 1;
            this.display_pagination = 1;
            this.$store.commit("loading/setIsLoading", true);
            this.$store.commit('mypage/useGolfCode', this.get_golf_code);
            this.ChangeGolfPointData();
            this.$store.commit("loading/setIsLoading", false);
        },
        ClickPagination: function (target, mode) {
            if (target === 'Limited') {
                // 前へボタン押下時処理
                if (mode === 'Previous') {
                    if (this.display_pagination > 1) {
                        this.display_pagination--;
                        if (this.display_pagination === 1) {
                            this.display_begin_row = 0;
                        } else {
                            this.display_begin_row = this.display_begin_row - this.display_limit_rows;
                        }
                        this.GetLimitedPointList();
                    } else {
                        return;
                    }
                } else {
                    // 次へボタン押下時処理
                    if (this.display_pagination < this.max_pagination) {
                        this.display_begin_row = this.display_begin_row + this.display_limit_rows;
                        this.display_pagination++;
                        this.GetLimitedPointList();
                    } else {
                        return;
                    }
                }
            }
        },
        GetLimitedPointList: function () {
            this.get_limited_point = [];
            this.$apollo.query({
                fetchPolicy: 'no-cache',
                query: GET_POINT_LIMITED_LIST,
                variables: {
                    member_no: this.from_set_data.member_no,
                    golf_group_code: process.env.MIX_GROUP_CODE,
                    golf_code: this.get_golf_code,
                    begin_row: this.display_begin_row,
                    limit_rows: this.display_limit_rows
                }
            }).then(res => {
                // 期間限定ポイントのデータ取得
                this.get_limited_point = res.data.getMemberLimitedPointList.MemberLimitedPointList;
                // 期間限定ポイントのデータ表示数
                this.get_limited_point_disp_count = res.data.getMemberLimitedPointList.MemberLimitedPointList.length;
                if (this.get_limited_point) {
                    // 期間期限ポイントの最大ページネーション数
                    if (res.data.getMemberLimitedPointList.count === 0) {
                        res.data.getMemberLimitedPointList.count = 1;
                    }
                    this.max_pagination = Math.ceil(res.data.getMemberLimitedPointList.count / this.display_limit_rows);
                }
            })
        },
        /** ----------------------------------------------
         * ゴルフ場毎のポイントの合計値と履歴データの取得処理
         * ---------------------------------------------- */
        ChangeGolfPointData: async function () {
            this.member_no = this.$store.state.auth.loginMember.member_no;
            this.get_limited_point = [];
            await this.$apollo.query({
                fetchPolicy: 'no-cache',
                query: GET_GOLF_COURSE_POINT_TOTAL,
                variables: {
                    member_no: this.member_no,
                    golf_group_code: process.env.MIX_GROUP_CODE,
                    golf_code: this.get_golf_code,
                    begin_row: this.display_begin_row,
                    limit_rows: this.display_limit_rows
                }
            }).then(res => {
                // ポイントの合計値取得
                if (!res.data.getGolfCoursePointTotal.total_point.total_all) {
                    this.total_points = 0;
                    this.total_normal = 0;
                    this.total_limited = 0;
                    this.min_valid_date_limited_normal = '';
                    this.min_valid_date_limited = '';
                } else {
                    this.total_points = res.data.getGolfCoursePointTotal.total_point.total_all;
                    this.total_normal = res.data.getGolfCoursePointTotal.total_point.total_normal;
                    this.total_limited = res.data.getGolfCoursePointTotal.total_point.total_limited;
                    this.min_valid_date_limited_normal = res.data.getGolfCoursePointTotal.valid_date.total_limited_normal;
                    this.min_valid_date_limited = res.data.getGolfCoursePointTotal.valid_date.total_limited;
                }
                if (!res.data.getGolfCoursePointTotal.total_point.total_expected) {
                    this.total_expected = 0;
                    this.expected_date = '';
                } else {
                    this.total_expected = res.data.getGolfCoursePointTotal.total_point.total_expected;
                    this.expected_date = res.data.getGolfCoursePointTotal.valid_date.expected_date;
                }
                if (!res.data.getGolfCoursePointTotal.total_point.total_reserve) {
                    this.total_reserve = 0;
                    this.play_date = '';
                } else {
                    this.total_reserve = res.data.getGolfCoursePointTotal.total_point.total_reserve;
                    this.play_date = res.data.getGolfCoursePointTotal.valid_date.play_date;
                }
                // 期間限定ポイントのデータ取得
                this.get_limited_point = res.data.getGolfCoursePointTotal.MemberLimitedPointList;
                // 期間限定ポイントのデータ表示数
                this.get_limited_point_disp_count = res.data.getGolfCoursePointTotal.MemberLimitedPointList.length;
                if (this.get_limited_point) {
                    // 期間期限ポイントの最大ページネーション数
                    if (res.data.getGolfCoursePointTotal.count === 0) {
                        res.data.getGolfCoursePointTotal.count = 1;
                    }
                    this.max_pagination = Math.ceil(res.data.getGolfCoursePointTotal.count / this.display_limit_rows);
                }
            })
        },
        GotoPoint: function () {
            // ポイント履歴画面へ遷移
            this.$router.push({ path: '/mypage-point' });
        },
        logOutBtn () {
            this.$store.commit("loading/setIsLoading", true);
            this.$store.commit("mypage/useGolfCode", null);
            this.$apollo.query({
                query: MEMBER_LOG_OUT,
                variables: {}
            }).then(res => {
                localStorage.removeItem('web-token');
                this.$router.push('/');
            }).catch(error => {
                this.$store.commit("loading/setIsLoading", false);
            });
        },
        openHelpPage() {
            window.open('/help', '_blank');
        },
        gotoPage(url) {
            this.$router.push(url);
        },
        gotoGolfCourseListPage() {
            this.$router.push({name: 'GolfCourseLisst', params: {show: true}});
        },
        showModal() {
            this.showMemberCode = true;
        },
        closeModal() {
            this.showMemberCode = false;
        }
    }
}
</script>

<style scoped>
/* SP表示時、1ページにつき3つテーブルが表示される仕様なので、
nページ目に変えても常に1、3番目のテーブル背景色がグレーに変わるようにしたい為、
2番目ではないテーブルの色を変更させる */
@media screen and (max-width: 896px) {
    .table-color:not(:nth-of-type(3n-1)){
        background-color: rgba(0, 0, 0, 0.05);
    }
}
.mypageTopIcon {
    background-color: #17a2b8;
    transform: scale(1.2);
    margin-left: 6px;
    margin-right: 8px;
}
.mypageTopWhiteIcon {
    background-color: #ffffff;
    transform: scale(1.2);
    margin-left: 6px;
    margin-right: 8px;
}
.menuWrap {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    row-gap: 20px;
    column-gap: 20px;
    padding: 30px 20px 30px 20px;
    justify-content: space-around;
    align-items: center;
}
.chatOff {
    visibility: hidden;
}
.menuItemWrap {
    display: flex;
    flex-direction: row;
    align-items: center;
}
.menuTitleWrap {
    display: flex;
    flex-direction: row;
    align-items: center;
    column-gap: 10px;
}
.menuText {
    font-size: 1.2rem;
    font-weight: bold;
}
.reserveInfoWrap {
    height: 3rem;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: center;
    column-gap: 20px;
}
.reserveNoInfoWrap {
    height: 3rem;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: left;
}
.playDateWrap {
    display: flex;
}
.codeBtnWrap {
    display: flex;
    justify-content: center;
    align-items: center;
}
@media screen and (max-width: 896px) {
    .reserveInfoWrap {
        height: 4rem;
        flex-direction: column-reverse;
        align-items: center;
        justify-content: flex-start;
        column-gap: 20px;
    }
    .reserveNoInfoWrap {
        justify-content: center;
    }
}
</style>
